import { $ } from "../third-party-imports"
export function stopLoaderWithDelay() {
    setTimeout(function ()
    {
    $('#loader-wrapper-img').removeClass('loader-wrapper-test');
    $('#img-loader').removeClass('loader-ring-test');
    $('#overlayrow').remove();
    }, 3000);
}